var exports = {
  "Z": "x31de4314--a9ce0a--information",
  "l": "x31de4314--a9ce0a--infoRow",
};

module.exports = exports;
